import { memo } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';

import styles from './CheckPluginModal.module.scss';

interface ICheckPluginModalProps {
  visible: boolean;
  setNextEntryCheckPlugin: () => void;
  setCheckPlugin: () => void;
}

export const CheckPluginModal = memo(({ visible, setNextEntryCheckPlugin, setCheckPlugin }: ICheckPluginModalProps) => {
  return (
    <Modal visible={visible} modalBodyClassName={styles.Modal} closeButtonClassName={styles.Close}>
      <ModalHeader title="Проверка наличия плагина CryptoPro" />
      <ModalBody size="content">
        <div className={styles.SubTitle}>Уважаемый пользователь!</div>
        <div className={styles.BodyText}>
          В соответствии с пп. 5 п. 4.2 Регламента подключения и интеграции ФГИС ЕРКНМ на АРМ сотрудников, которым
          необходим доступ к закрытой части должно быть установлено следующее программное обеспечение:
        </div>
        <ul className={styles.BodyList}>
          <li>КриптоПро CSP версии 3.6 R4 и выше;</li>
          <li>КриптоПро ЭЦП Browser plug-in</li>
        </ul>
        <div className={styles.BodyText}>
          ФГИС ЕРКНМ не обнаружила установленного КриптоПро ЭЦП Browser plug-in, поэтому, вам будет недоступен ряд
          функций системы, а именно подписание проверок и планов, и, соответственно, возможность проводить согласование
          планов/проверок.
        </div>
        <div className={styles.BodyText}>
          Пожалуйста, установите требуемое программное обеспечение. В случае, если вы планируете использовать
          открепленную подпись для работы в системе, нажмите соответствующую кнопку ниже.
        </div>
      </ModalBody>
      <ModalActions direction="column">
        <Button
          text="Информация принята, на данный АРМ будет установлено необходимое ПО"
          color="primary"
          size="small"
          onClick={setNextEntryCheckPlugin}
        />
        <Button
          text="Информация принята, на данном АРМ будет использоваться ПО для открепленной подписи"
          color="primary"
          size="small"
          onClick={setCheckPlugin}
        />
      </ModalActions>
    </Modal>
  );
});
